<li class="nav-item" *ngIf="badge_text !== '0'">
    <a class="nav-link" [matBadge]="badge_text" [matBadgeHidden]="badge_text === '0'" matBadgeOverlap="true"
        [matBadgeColor]="badge_color" (click)="openNotifications()">
        <fa-icon [icon]="icon" [fixedWidth]="true"></fa-icon>
    </a>
</li>
